module.exports = __webpack_public_path__ + "img/26.bd7b528a.png";